import React, { useEffect } from 'react';

interface FacebookSDKLoaderProps {
  appId: string;
  version?: string;
  onSDKLoad?: () => void;
}

const FacebookSDKLoader: React.FC<FacebookSDKLoaderProps> = ({
  appId,
  version = 'v21.0',
  onSDKLoad,
}) => {
  useEffect(() => {
    // Check if the SDK script is already present
    if (document.getElementById('facebook-jssdk')) {
      // Ensure FB is initialized
      if (window.FB) {
        onSDKLoad?.();
      } else {
        // Wait for fbAsyncInit to be called
        const checkFBInit = setInterval(() => {
          if (window.FB) {
            clearInterval(checkFBInit);
            onSDKLoad?.();
          }
        }, 100);
      }
      return;
    }

    // Initialize the SDK after it's loaded
    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        cookie: true,
        xfbml: true,
        version,
      });

      window.FB.AppEvents.logPageView();
      onSDKLoad?.();
    };

    // Load the SDK script
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs?.parentNode?.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    // Cleanup function to remove the SDK script and global variables
    return () => {
      // Remove the SDK script from the document
      const sdkScript = document.getElementById('facebook-jssdk');
      sdkScript?.parentNode?.removeChild(sdkScript);

      // Clean up global variables
      delete window.FB;
      delete window.fbAsyncInit;
    };
  }, [appId, version, onSDKLoad]);

  return null; // Ensure the component returns a valid React node
};

export default FacebookSDKLoader;
